// @flow

import styled, { css } from 'styled-components';
import { media } from '../../../../helpers';
import { BOLD } from '../../../../helpers/fontWeight';
import type { Theme } from '../../../../types';
import DefaultPrice from '../../../price';

const Price = styled<typeof DefaultPrice, Theme, _>(DefaultPrice)`
  display: block;
  color: ${props => props.theme.carblock.price.color};
  font-size: ${props => props.theme.carblock.price.fontSize.default};
  font-weight: ${BOLD};
  margin-right: .75rem;
  ${media.lg(css`
    font-size: ${props => props.theme.carblock.price.fontSize.lg};
  `)}
`;

export default Price;
